export default __webpack_public_path__ + "static/media/FREQ.CARDIACA_ICONA.fea4aed9.svg";